export const baseUrl = process.env.REACT_APP_API_URL;
export const Key = process.env.REACT_APP_API_MAP_KEY;
console.log(baseUrl);
